<script lang="ts" setup>
import { useGlobalData } from '@/utils/useGlobal';
const { config } = useGlobalData()

defineProps({
  isShowPrizeName: {
    type: Boolean,
    default: true
  }
})

</script>
<template>
  <ul v-if="config.subscribePrize.list.length" class="gift-list">
    <li v-for="item in config.subscribePrize.list" :key="item.name" class="gift-item">
      <div class="gift-box">
        <img :src="item.imgUrl" :alt="item.name">
      </div>
      <span v-if="isShowPrizeName" class="gift-name">{{ item.name }}</span>
    </li>
  </ul>
</template>

<style lang="less" scoped>
.gift-list{
  display: flex;
  margin-top:0.16rem;
  font-size: 0.18rem;
  color: #130E08;
  .gift-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1.2rem;
    margin: 0 0.05rem;
  }
  .gift-box{
    display: flex;
    align-items: center;
    justify-content: center;
    width:0.66rem;
    height:0.66rem;
    background: url("~/images/section1/prize-bg.png") no-repeat 0 0 / 100%;
    & > img{
      width: 63%;
    }
  }
  .gift-name{
    width: 100%;
    height: 0.24rem;
    margin-top: 0.08rem;
    overflow: hidden;
    font-size: 0.15rem;
    line-height: 0.24rem;
    text-align: center;
  }
}
</style>
